/* src/app/shared/clearing/clearing-display/clearing-display.component.scss */
:host > .cw-button-wrapper {
  justify-content: space-between;
}
:host ::ng-deep phscw-grid tr.disabled,
:host ::ng-deep phscw-grid tr.disabled td.mat-mdc-cell {
  color: var(--color-primary);
  pointer-events: none;
}
/*# sourceMappingURL=clearing-display.component.css.map */
